export type SalesProfile = {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  address: string;
  profilePicture: string;
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchSalesProfile() {
  const response = await fetch("/api/sales/profile", {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as SalesProfile;
}

export async function updateSalesProfile(input: {
  firstName: string;
  middleName?: string;
  lastName?: string;
  phone?: string;
}) {
  const response = await fetch("/api/sales/profile", {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(input)
  });

  return parseResponse(response);
}
